import { gql } from '@apollo/client';
import { SECTION_FRAGMENT } from './section.newsletter.graphql';
import { NEWSLETTER_FRAGMENT } from './newsletter.newsletter.graphql';

export const CAMPAIGN_FRAGMENT = gql`
  fragment Campaign on Campaign {
    id
    _id
    subject
    preHeader
    availableAt
    url
    utmContent
    createdAt
    updatedAt
    lockedAt
    lockedBy {
      id
      name
      email
      avatarUrl
    }
    newsletter {
      ...Newsletter
    }
    medias {
      caption
      focusPoint
      format
      href
      iframely
      src
      title
      url
    }
    sections(first: 200, orderBy: position_ASC) {
      ...Section
    }
    campaignHistories(first: 100, orderBy: createdAt_DESC) {
      id
      createdAt
      userName
    }
  }
  ${SECTION_FRAGMENT}
  ${NEWSLETTER_FRAGMENT}
`;
